import React, {Component} from 'react';
import InputWrap from "./InputWrap";

class Input extends Component {

    constructor(props) {
        super();
        this.state = {
            focused: false
        };
        this._handleBlur = this._handleBlur.bind(this);
        this._handleFocus = this._handleFocus.bind(this);
    }

    componentDidMount() {
        this.setupValue(this.props)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.input && this.props.input.value !== prevProps.input.value) {
            this.setupValue(this.props)
        }
    }

    setupValue(props) {
        const {defaultValue, input} = props;

        const onChange = input && input.onChange ? input.onChange : props.onChange;

        if (defaultValue && input && !input.value) {
            onChange(defaultValue)
        }
    }

    _handleFocus(e) {
        this.setState({
            focused: true
        })
        if (this.props.onFocus) {
            this.props.onFocus(e)
        }
    }

    _handleBlur(e) {
        this.setState({
            focused: false
        })

        if (this.props.onBlur) {
            this.props.onBlur(e)
        }
    }

    render() {
        const {onChange, id, name, type, placeholder, input, disabled} = this.props;
        const {focused} = this.state;

        let inputType = "text";
        switch (type) {
            case "search":
                inputType = "text";
                break;
            case "number":
                inputType = "number";
                break;
            default:
                inputType = "text";
                break;
        }

        const inputWrapProps = {
            ...this.props,
            focused: focused
        }

        let inputProps = {}
        if (input) {
            inputProps = {
                ...input,
            }
        } else {
            inputProps = {
                ...this.props
            }
        }
        return (
            <InputWrap {...inputWrapProps}>
                <input
                    {...inputProps}
                    type={inputType || "text"}
                    id={id}
                    name={name || id}
                    placeholder={placeholder}
                    onChange={onChange || inputProps.onChange}
                    onFocus={this._handleFocus}
                    onBlur={this._handleBlur}
                    disabled={disabled}
                />
            </InputWrap>
        );
    };
}

export default Input;



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/Input.js